export const NoBatching: Record<string, boolean> = {
  doNotBatch: true,
};
